import MoreIcon from "components/icons/moreIcon.svg?react";
import "./MoreTagsButton.scss";

export const MoreTagsButton = (props: {
  onClick: () => void;
}): JSX.Element => {
  return (
    <button className="more moreTags" onClick={props.onClick} aria-label="show more tags button">
      <MoreIcon />
    </button>
  );
};
